export default __webpack_public_path__ + "static/media/sn.12a64e97.svg";